import React, {useState, useEffect} from 'react';
import 'bootstrap/dist/css/bootstrap.min.css';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import InputText from '../FormFields/InputText';
import SelectInfinite from '../FormFields/SelectInfinite';
import TextArea from '../FormFields/Textarea';
import {useForm, FormProvider} from 'react-hook-form';
import {yupResolver} from '@hookform/resolvers';
import {getLanguage, t} from 'react-switch-lang';
import * as yup from 'yup';
import ModalHistory from '../../app/Measures/components/ShowHistoryModal';
import ModalVerify from '../../app/Measures/components/VerifyModal';
import Toast from '../toast/Toast';
import SelectList from '../../components/FormFields/select/SelectList';
import PreventTransitionPrompt from '../preventTransitionprompt/PreventTransition';
import {updateControl} from "../../services/controlsService/controlsApi";
import {
    controlAssessmentOptions,
    controlTypeOptions,
    controlFrequencyOptions,
    purposeOptions
} from "../../utils/controlsConstants";
import {appModules} from '../../utils/const';

function ControlsFormShow({
                              data, toggleOpen, open, riskId, departmentData, riskTitle, allowEdit, risk
                          }) {
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [isModalVerifyOpen, setIsModalVerifyOpen] = useState(false);
    const [disabled, setDisabled] = useState(true);
    const [disableBtn, setDisableBtn] = useState(false);

    const lang = getLanguage();

    const [schema, setScheme] = useState(yup.object().shape({
        name: yup
            .string()
            .nullable()
            .trim()
            .required(t('message.fieldRequired')), description: yup
            .string()
            .nullable()
            .trim()
            .required(t('message.fieldRequired')), purpose: yup
            .object()
            .nullable()
            .required(t('message.fieldRequired')), type: yup
            .object()
            .nullable()
            .required(t('message.fieldRequired')), frequency: yup
            .object()
            .nullable()
            .required(t('message.fieldRequired')), evidence: yup
            .string()
            .nullable()
            .trim()
            .required(t('message.fieldRequired')), controlAssessment: yup
            .object()
            .nullable()
            .required(t('message.fieldRequired')), department: yup.object().nullable(),
    }));


    const methods = useForm({
        resolver: yupResolver(schema),
    });

    const {handleSubmit, errors, watch, setValue} = methods;

    const submitForm = async (submitedData) => {
        setDisableBtn(true);

        const payload = {
            name: submitedData.name,
            description: submitedData.description,
            purpose: submitedData.purpose.value,
            type: submitedData.type.value,
            frequency: submitedData.frequency.value,
            evidence: submitedData.evidence,
            controlAssessment: submitedData.controlAssessment.value,
            department: {id: submitedData.department.value, name: submitedData.department.label},
            id: data.id,
            risk: risk
        };
        try {
            const response = await updateControl(payload);
            if (response.status === 200) {
                await Toast.fire({
                    title: t('message.updateSuccess3', {entity: t('common.control')}), icon: 'success',
                });
            }
            // toggleOpen(!open);
            setDisabled(true);
            await window.location.reload();
            setDisableBtn(false);
        } catch (err) {
            setDisableBtn(false);
            if (err.response.data.code === 'risk_control_name_already_exists_for_specified_risk') {
                await Toast.fire({
                    title: t('controls.controlNameExists'), icon: 'error',
                });
            }
            if (err.response.code === 'file-format') {
                await Toast.fire({
                    title: t('message.fileFormatNotAllowed'), icon: 'error',
                });
            }
            if (err.response.status === 400) {
                await Toast.fire({
                    title: t('message.errorApi'), icon: 'error',
                });
            }
        }
    };

    const handleCancel = (e) => {
        e.preventDefault();
        toggleOpen(!open);
        setDisabled(true);
    };

    const setEdit = (e) => {
        e && e.preventDefault();
        setDisabled(false);
    };

    useEffect(() => {
        if (disabled === false) {
            setDisabled(true);
        }
    }, [open]);

    return (<>
        <PreventTransitionPrompt when={!disabled}/>
        <FormProvider {...methods}>
            <form onSubmit={handleSubmit(submitForm)}>
                <Row className="mb-5 main-form">
                    <Col xs={6} md={6} lg={3}>
                        <label className="label-measures">
                            {t('controls.controlName')}
                        </label>
                        <InputText
                            name="name"
                            className="form-control input-field"
                            placeholder={t('controls.controlNamePlaceholder')}
                            isClearable={false}
                            errors={errors}
                            defaultValue={data?.name}
                            disabled={disabled}
                        />
                        <label className="label-measures">
                            {t('controls.controlDescription')}
                        </label>
                        <TextArea
                            name="description"
                            className={`form-control height text-area`}
                            placeholder={t('controls.controlDescriptionPlaceholder')}
                            errors={errors}
                            defaultValue={data?.description}
                            disabled={disabled}
                        />
                    </Col>
                    <Col xs={6} md={6} lg={3}>
                        <label className="label-measures">
                            {t('controls.purposeLabel')}
                        </label>
                        <SelectList
                            name="purpose"
                            className="select"
                            options={purposeOptions}
                            placeholder={t('controls.purposePlaceholder')}
                            isClearable={false}
                            errors={errors}
                            isDisabled={disabled}
                            defaultValue={{
                                value: data?.purpose, label: t(`controls.${data?.purpose.toLowerCase()}`)
                            }}
                        />
                        <label className="label-measures">
                            {t('controls.controlType')}
                        </label>
                        <SelectList
                            name="type"
                            className="select"
                            options={controlTypeOptions}
                            placeholder={t('controls.controlTypePlaceholder')}
                            isClearable={false}
                            isDisabled={disabled}
                            errors={errors}
                            defaultValue={{
                                value: data?.type, label: t(`controls.${data?.type.toLowerCase()}`)
                            }}
                        />
                    </Col>
                    <Col xs={6} md={6} lg={3}>
                        <label className="label-measures">
                            {t('controls.controlFrequency')}
                        </label>
                        <SelectList
                            name="frequency"
                            className="select"
                            options={controlFrequencyOptions}
                            placeholder={t('controls.controlFrequencyPlaceholder')}
                            isClearable={false}
                            isDisabled={disabled}
                            errors={errors}
                            defaultValue={{
                                value: data?.frequency, label: t(`controls.${data?.frequency.toLowerCase()}`)
                            }}
                        />
                        <label className="label-measures">
                            {t('controls.controlEvidence')}
                        </label>
                        <TextArea
                            name="evidence"
                            className={`form-control height text-area`}
                            placeholder={t('controls.controlEvidencePlaceholder')}
                            disabled={disabled}
                            errors={errors}
                            defaultValue={data?.evidence}
                        />
                    </Col>
                    <Col xs={6} md={6} lg={3}>
                        <label className="label-measures">
                            {t('controls.controlRate')}
                        </label>
                        <SelectList
                            name="controlAssessment"
                            className="select"
                            options={controlAssessmentOptions}
                            placeholder={t('controls.controlRatePlaceholder')}
                            isClearable={false}
                            errors={errors}
                            isDisabled={disabled}
                            defaultValue={{
                                value: data?.controlAssessment,
                                label: t(`controls.${data?.controlAssessment.toLowerCase()}`)
                            }}
                        />
                        <label className="label-measures">
                            {t('controls.department')}
                        </label>
                        <SelectInfinite
                          api={`departments?appModuleId.equals=${appModules?.riskModule}&active.equals=true`}
                          name="department"
                            labelKey={lang === 'mne' ? 'name' : 'nameEn'}
                            defaultValue={{
                                value: data.department?.id, label: data.department?.name,
                            }}
                            className="department"
                            placeholder={t('risk-cosideration.search.organizedUnit')}
                            isDisabled={disabled}
                            isClearable={false}
                        />
                    </Col>
                </Row>
                <Row className="mb-3 pt-3 right-btns">
                    <Col lg={12} className="btns-float-right">
                        {allowEdit && disabled && data.measureStatus !== 'CLOSED' && (<button
                            className="btn btn-primary btn-strong ml-2"
                            onClick={(e) => setEdit(e)}
                        >
                            {t('buttons.changeBtn')}
                        </button>)}

                        {disabled === false && (<>
                            <button
                                className="btn btn-cancel btn-strong"
                                type="reset"
                                onClick={handleCancel}
                            >
                                {t('buttons.cancelBtn')}
                            </button>
                            <button
                                className="btn btn-primary btn-strong"
                                disabled={disableBtn}
                            >
                                {t('buttons.saveBtn')}
                            </button>
                        </>)}
                    </Col>
                </Row>
            </form>
        </FormProvider>

        <ModalHistory
            data={data.id}
            open={isModalOpen}
            isOpen={(e) => setIsModalOpen(e)}
        />
        <ModalVerify
            open={isModalVerifyOpen}
            id={data.id}
            isOpen={(e) => setIsModalVerifyOpen(e)}
        />
    </>);
}

export default ControlsFormShow;
